<template>
  <div class="container">
    <div class="center-left">
      <div class="login-box">
        <div class="avatar">
          <img src="#" alt="头像">
        </div>
        <div class="user-desc">
          <span><a href="#">立即登录</a></span>
          <span><a href="#">注册</a></span>
        </div>
      </div>
      <!-- 如果没有登录就显示简介详情，登录后就显示功能按钮 -->
      <div class="desc">
        <div>吃掉那只青蛙</div>
        <div>本网站域名来自《吃掉那只青蛙》，希望我们每个人都克服拖延的坏毛病，本网站打算设计出完美的内容供大家使用。</div>
        <div>时间</div>
        <div>女子低头不见脚尖，便已具人间绝色。</div>
      </div>
    </div>
    <div class="center-center">
      <span>最新文章</span>
      <div class="article">
        <div class="article-title">《剑来》读后有感</div>
        <div class="article-content">齐先生，我想明白了，对世界不要失去希望，除了一定要好好活着之外，其实还有一层意思，就是当我们对这个世界给予善意，却没有得到善意的回报，甚至只有恶意时，还能够不失望，才是真正的希望。齐先生，我现在已经想明白了，但是暂时还做不到，我喝过了酒，明天就努力</div>
        <div class="article-info">
          <div>
            <span class="iconfont icon-riqishijian_line"></span>
            <span>2026年7月16日 11:27:00</span>
          </div>
          <div>
            <span class="iconfont icon-tushu"></span>
            <span>共1000字</span>
          </div>
          <div>
            <span class="iconfont icon-zuozhe"></span>
            <span>作者: xingcczh</span>
          </div>
        </div>
        <div class="article-label">
          <span class="iconfont icon-biaoqian"></span>
          <span>#小说</span>
          <span>#日记</span>
        </div>
      </div>
      <div>内容二</div>
    </div>
    <div class="center-right">标签</div>
  </div>
</template>

<script>
export default {
  name: 'HomeCenter'

}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  gap: 2;
  .center-left {
    flex: 1;
    // background-color: rebeccapurple;
    // opacity: 30%;
    height: 80vh;
    @media (max-width: 768px) {
      display: none;
    }
    .login-box {
      // background-color: aqua;
      background-color: rgb(255, 255, 255);
      height: 250px;
      padding: 20px;
      .user-desc {
        width: 100%;
        margin: 20px auto;
      }
    }
    .desc {
      margin: 10px auto;
      padding: 20px;
      // border: 1px solid;
      border-radius: 15px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      background-color: rgb(255, 255, 255);
    }
  }
  .center-center {
    flex: 4;
    padding: 5px 5px;
    .article {
      margin: 15px auto;
      padding: 25px;
      // border: 2px solid;
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      background-color: rgb(255, 255, 255);
      .article-title {
        font-size: 26px;
        font-weight: 600;
      }
      .article-content {
        font-size: 14px;
        font-weight: 400;
      }
      .article-info {
        display: flex;
        gap: 40px;
      }
      .article-label {
        display: flex;
        gap: 20px;
      }
    }
  }
  .center-right {
    flex: 1;
    background-color: rgb(255, 255, 255);
    @media (max-width: 768px) {
      display: none;
    }
  }
}

</style>>
